module.exports = __webpack_public_path__ + "assets/img/play_game.7b58a65f.png";